import React from "react";
import Banner from "./Banner";
import MightyBenefits from "./MightyBenefits";
//import MeetMighty from "../../layout/MeetMighty";
import Promotion from "../../layout/Promotion";
import StayTouch from "../../layout/StayTouch";
import AnyQuestions from "../../reusable/AnyQuestions";
import layoutWrapper from "../../components/Hoc/layoutWrapper";
class AboutUs extends React.Component {
  render() {
    return (
      <div>
        <Banner />
        <Promotion />
        <AnyQuestions />
        <StayTouch />
      </div>
    );
  }
}

export default layoutWrapper(AboutUs);



// WEBPACK FOOTER //
// ./src/pages/about/index.js